import { useState, useEffect } from "react";
//import { AiOutlineStar } from "react-icons/ai";
//import { BiGitRepoForked } from "react-icons/bi";
import SocialIcons from "../components/SocialIcons";
import Badkonak from './../template/Badkonak';
const Footer = () => {
  const date = new Date();
  const currentYear = date.getFullYear();

  const [ setGitHubInfo] = useState({
    stars: null,
    forks: null,
  });

  useEffect(() => {
    fetch("https://github.com/Shahab-NG/shahab-ng.github.io")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response;
      })
      .then((res) => res.json())
      .then((json) => {
        const { stargazers_count, forks_count } = json;
        setGitHubInfo({
          stars: stargazers_count,
          forks: forks_count,
        });
      })
      .catch((e) => console.error(e));
  }, );

  return (
    <footer>
      <SocialIcons />
      <a className="footer-link" href="https://github.com/Shahab-NG" target="_blank" rel="noopener noreferrer">
        <p>
          <span>⭐</span> {setGitHubInfo.stars} Stars
        </p>
        <p>
          <span>🍴</span> {setGitHubInfo.forks} Forks 
        </p>
        
        <p>
          <span>▷</span>  &copy; {currentYear}
        </p>
        <p>Shahab Naghibi</p>
      </a>
      <Badkonak/>

    </footer>
  );
};

export default Footer;

